export default __webpack_public_path__ + "static/media/satisfaction.61687bed.svg";